import styled from 'styled-components';
import { gridSizes } from 'utils/style';
import ModalSummary from './ModalSummary';

export default styled(ModalSummary)`
  margin: 0;
  padding: ${gridSizes('S')} ${gridSizes('L')} ${gridSizes('L')};
  border-bottom: solid 1px var(--grey300);
`;
